import { Modal } from "../../modal-base";
import { Close, Check } from "@mui/icons-material";
import {
  ButtonContainer,
  CriterioRadioContainer,
  ModalContent,
} from "./styles";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { toast } from "react-toastify";
import { useState } from "react";
import { ScenariosService } from "@/modules/scenarios/services";
import permissionsStore from "../../../store/permissions";
import { setDefaultScenario, updateScenarioId } from "@/utils/setDefaultScenario";

interface ISelectCriterio {
  modal: boolean;
  toggleModal: () => void;
  selectedAccountCombo: number;
}

export const SelectCriterio: React.FC<ISelectCriterio> = ({
  modal,
  toggleModal,
  selectedAccountCombo,
}) => {
  const { scenarioId, storageUser, setScenarioId } = permissionsStore();
  const [criterioType, setCriterioType] = useState<string>("");

  const handleCriterio = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCriterioType((event.target as HTMLInputElement).value as string);
  }

  const createCriterio = async (titlePrompt: string, prompt: string) => {
    try {
      const response = await ScenariosService.createScenario(
        titlePrompt,
        prompt,
        selectedAccountCombo
      );
      if (response?.success) {
        if (criterioType !== "customCriterio") {
          const result = await setDefaultScenario(selectedAccountCombo, response.scenarioId!, storageUser!.id);
          if (result.success) {
            setScenarioId(updateScenarioId(selectedAccountCombo, scenarioId, response.scenarioId!));
          } else {
            toast.error("Ocorreu um erro ao alterar o critério.");
          }
        }
      } else {
        toast.error("Ocorreu um erro ao atualizar o critério.");
      }
    } catch (error) {
      toast.error("Ocorreu um erro ao atualizar o critério.");
      console.error("Erro ao atualizar critério:", error);
    }
  };

  function buildPrompt(
    criterioType: string,
  ): { titleContent: string, promptContent: string } | false {
    if (criterioType === "") return false;

    let promptContent = "";
    let titleContent = "";

    switch (criterioType) {
      case "comercial":
        titleContent = "Comercial";
        promptContent = "Criminal;;PASSIVO;;false";
        break;
      case "rhContratacao":
        titleContent = "RH - Contratação";
        promptContent = "Trabalhista;ATIVO;PASSIVO;;false";
        break;
      case "comercialContratacao":
        titleContent = "Comercial + RH - Contratação";
        promptContent =
          "Criminal;;PASSIVO;;false\nTrabalhista;ATIVO;PASSIVO;;false";
        break;
      case "customCriterio":
        titleContent = "Critério Padrão";
        promptContent = "";
        break;
    }
    return { titleContent, promptContent }
  }

  return (
    <Modal.Root maxWidth="600px" open={modal} onClose={toggleModal}>
      <Modal.Header justifyContent="end">
        <Modal.HeaderText text={"Configuração de critério"} />
        <Modal.Icon
          icon="Close"
          cursor="pointer"
          onClick={toggleModal}
          iconColor="black"
        />
      </Modal.Header>
      <Modal.Content>
        <ModalContent>
          <CriterioRadioContainer>
            <span className="title">
              Selecione um critério para <strong>REPROVAÇÃO</strong> das
              análises:
            </span>
            <RadioGroup
              aria-labelledby="user-type"
              name="controlled-radio-buttons-group"
              value={criterioType}
              onChange={handleCriterio}
            >
              <FormControlLabel
                value="comercial"
                control={<Radio />}
                label="Comercial"
                sx={{
                  color: "black",
                }}
              />
              <p className="description">
                Verifica a existência de ações judiciais em que o consultado
                figure como Réu em processos criminais, identificando possíveis
                antecedentes que possam indicar seu envolvimento em atividades
                ilícitas ou condutas criminosas.{" "}
              </p>
              <FormControlLabel
                value="rhContratacao"
                control={<Radio />}
                label="RH - Contratação"
                sx={{
                  color: "black",
                }}
              />
              <p className="description">
                Tem foco em ações trabalhistas e pode reprovar um candidato caso
                ele esteja listado como Réu, respondendo a processos movidos
                contra ele, ou como Ativo, sendo o autor de ações trabalhistas
                contra empregadores.{" "}
              </p>
              <FormControlLabel
                value="comercialContratacao"
                control={<Radio />}
                label="Comercial + RH - Contratação"
                sx={{
                  color: "black",
                }}
              />
              <p className="description">
                Essa opção permite que o usuário defina manualmente as regras de
                reprovação, selecionando critérios com base nas esferas
                criminal, cível, trabalhista e eleitoral, personalizando a
                análise conforme suas necessidades.
              </p>
              <FormControlLabel
                value="customCriterio"
                control={<Radio />}
                label="Customizar meu critério"
                sx={{
                  color: "black",
                }}
              />
              <p className="description">
                O usuário cria um critério e seleciona manualmente quais dessas
                condições devem ser levadas em conta na reprovação. Dessa forma,
                o sistema assegura um controle mais preciso e automatizado,
                permitindo que empresas tomem decisões embasadas em informações
                judiciais relevantes.
              </p>
            </RadioGroup>
          </CriterioRadioContainer>
        </ModalContent>
        <ButtonContainer>
          <Modal.Button
            onClick={() => {
              const result = buildPrompt(criterioType);
              if (result) createCriterio(result.titleContent, result.promptContent)
              toggleModal();
            }}
            startIcon={<Check />}
            bgColor="#2C2C2C"
            color="white"
            disabled={criterioType == ""}
          >
            Continuar
          </Modal.Button>
          <Modal.Button onClick={toggleModal} startIcon={<Close />} bgColor="">
            Cancelar
          </Modal.Button>
        </ButtonContainer>
      </Modal.Content>
    </Modal.Root>
  );
};
